@if (showLoadingSpinner) {
  <div class="text-center">
    <qa-loading-spinner />
  </div>
}
@if (!showLoadingSpinner && errorHappened) {
  <div class="center alert">
    <p>Comparison statistics not available!</p>
  </div>
}
@if (!showLoadingSpinner && !errorHappened) {
  <div class="grid no-gutters">
    <!--<div *ngIf="(comparisonTable$|async) as table" class="grid no-gutters">-->
    <div class="col-12">
      <p-panel [toggleable]="true" [collapsed]="true" class="validation-row">
        <ng-template pTemplate="header">
          <div class="text-center my-1" style="width: 92%">
            <p class="my-0 font-weight-normal">Comparison statistics</p>
          </div>
        </ng-template>
        <ng-template pTemplate="icons">
          <label
            class="mb-0 p-panel-header-icon"
            pTooltip="Expand this section to inspect a table with the metric-wise difference of the two datasets."
            tooltipPosition="bottom"
          >
            <span class="pi pi-question-circle help-icon"></span>
          </label>
        </ng-template>
        <div class="pb-3">
          Shown are the median values for each metric in the two comparison
          datasets, and their difference.
        </div>
        <div class="py3">
          <span [innerHtml]="table"></span>
          <div class="d-flex justify-content-between align-items-center">
            <button
              pButton
              type="button"
              class="btn-action-large"
              title="Download the table to a .csv file"
              label=" Download .csv table"
              icon="pi pi-download"
              (click)="getComparisonTableAsCsv()"
            ></button>
          </div>
        </div>
      </p-panel>
    </div>
  </div>
}
